"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var jsx_runtime_1 = require("preact/jsx-runtime");
var Header_1 = require("../Header");
var Destination_1 = require("../Destination");
var Footer_1 = require("../Footer");
var hooks_1 = require("preact/hooks");
require("./index.css");
var Loading_1 = require("../Loading");
var Quotes_1 = require("../Quotes");
var helper_1 = require("../../helper");
var requests_1 = require("../../requests");
var Disqualified_1 = require("../Disqualified");
var ModalStatus_1 = require("../../ModalStatus");
var Modal = function (_a) {
    var estimateBody = _a.estimateBody, onClose = _a.onClose, config = _a.config;
    var position = config.style.position;
    var _b = (0, hooks_1.useState)(), destination = _b[0], setDestination = _b[1];
    var _c = (0, hooks_1.useState)(''), parsedOrigin = _c[0], setParsedOrigin = _c[1];
    var _d = (0, hooks_1.useState)(ModalStatus_1.ModalStatus.LOADING), status = _d[0], setStatus = _d[1];
    var _e = (0, hooks_1.useState)(), hostedSession = _e[0], setHostedSession = _e[1];
    var _f = (0, hooks_1.useState)(), quoteRequest = _f[0], setQuoteRequest = _f[1];
    var _g = (0, hooks_1.useState)(), errors = _g[0], setErrors = _g[1];
    var style = (0, helper_1.getEstimateStyle)(config);
    (0, hooks_1.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var session;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setErrors([]);
                        setStatus(ModalStatus_1.ModalStatus.LOADING);
                        return [4 /*yield*/, (0, requests_1.loadHostedSessions)(config, estimateBody)];
                    case 1:
                        session = _a.sent();
                        setHostedSession(session);
                        setParsedOrigin((0, helper_1.parseEstimatedLocation)(session.origin));
                        setStatus(ModalStatus_1.ModalStatus.OPEN);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [estimateBody.origin, estimateBody.objects]);
    (0, hooks_1.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var esimate, sess, req, errorMessages;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setErrors([]);
                        if (!destination) {
                            return [2 /*return*/];
                        }
                        setStatus(ModalStatus_1.ModalStatus.LOADING);
                        esimate = __assign(__assign({}, estimateBody), { destination: destination });
                        sess = hostedSession
                            ? hostedSession
                            : { id: '', private_token: '', origin: estimateBody.origin };
                        return [4 /*yield*/, (0, requests_1.loadQuoteRequests)(config, sess, esimate)];
                    case 1:
                        req = _a.sent();
                        if (req.err) {
                            errorMessages = (0, helper_1.parseErrors)(req.err.errors);
                            setErrors(errorMessages);
                            setStatus(ModalStatus_1.ModalStatus.OPEN);
                        }
                        else {
                            setQuoteRequest(req);
                            if (req.quotes && req.quotes.length > 0) {
                                setStatus(ModalStatus_1.ModalStatus.QUOTED);
                            }
                            else {
                                setStatus(ModalStatus_1.ModalStatus.DISQUALIFIED);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [destination]);
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", { class: "artajs", children: [position === 'center' && (0, jsx_runtime_1.jsx)("div", { class: "artajs__modal__backdrop" }), (0, jsx_runtime_1.jsxs)("div", { class: "artajs__modal artajs__modal__".concat(position), style: style, children: [(0, jsx_runtime_1.jsx)(Header_1.Header, { onClose: onClose, title: config.text.header.title, lineColor: config.style.color.border }), status === ModalStatus_1.ModalStatus.LOADING && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Loading_1.Loading, {}), (0, jsx_runtime_1.jsx)(Footer_1.Footer, { absolute: true })] })), status === ModalStatus_1.ModalStatus.OPEN && ((0, jsx_runtime_1.jsx)(Destination_1.Destination, { parsedOrigin: parsedOrigin, textConfig: (0, helper_1.getDestinationConfig)(config), setDestination: setDestination })), status === ModalStatus_1.ModalStatus.QUOTED && quoteRequest && ((0, jsx_runtime_1.jsx)(Quotes_1.Quotes, { quoteRequest: quoteRequest, showCostRange: config.style.pricingDisplay === 'range', textConfig: (0, helper_1.getQuoteConfig)(config), setStatus: setStatus })), status === ModalStatus_1.ModalStatus.DISQUALIFIED && quoteRequest && ((0, jsx_runtime_1.jsx)(Disqualified_1.Disqualified, { quoteRequest: quoteRequest, textConfig: (0, helper_1.getDisqualifiedConfig)(config), setStatus: setStatus })), status !== ModalStatus_1.ModalStatus.LOADING && (0, jsx_runtime_1.jsx)(Footer_1.Footer, {}), errors && errors.length > 0 && ((0, jsx_runtime_1.jsxs)("div", { class: "artajs__modal__error__container", children: [(0, jsx_runtime_1.jsx)("div", { class: "artajs__modal__error", children: errors.map(function (error, i) {
                                        return (0, jsx_runtime_1.jsx)("span", { children: error }, "arta-error-".concat(i));
                                    }) }), (0, jsx_runtime_1.jsx)("div", { className: "artajs__modal__error__close", children: (0, jsx_runtime_1.jsx)("a", { onClick: function () { return setErrors([]); }, href: "#", children: (0, jsx_runtime_1.jsxs)("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0, jsx_runtime_1.jsx)("line", { x1: "6.70711", y1: "6.29289", x2: "18.0208", y2: "17.6066", "stroke-width": "2" }), (0, jsx_runtime_1.jsx)("line", { x1: "6.29289", y1: "17.6066", x2: "17.6066", y2: "6.29291", "stroke-width": "2" })] }) }) })] }))] })] }) }));
};
exports.Modal = Modal;
